import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PartialJobInterface, JobQuestion } from "./dto";
import { QueryKeys } from "config/query-keys";
import { db } from '../../firebase/firebase';
import { collection, addDoc, Timestamp, updateDoc } from 'firebase/firestore';

export const postJobs = async (data: PartialJobInterface): Promise<{}> => {

  const job_collection_ref = collection(db, 'jobs');

  const deadlineAt = data.deadlineAt ? Timestamp.fromDate(data.deadlineAt.toDate()) : "";

  const questions: JobQuestion[] = Array.isArray(data.questions)
    ? data.questions
        .map(q => ({
          question: q.question,
          type: q.type,
          isOptional: q.isOptional ?? false
        }))
        .filter(q => q.question && q.type)
    : [];


  const formattedData = Object.fromEntries(
    Object.entries({
      ...data,
      numberOfVacancy: data.numberOfVacancy,
      skills: data.skills,
      joblocation: data.joblocation,
      deadlineAt: deadlineAt,
      questions: questions,
      createdAt: Timestamp.now(),
    }).filter(([_, value]) => value !== undefined)
  );

  const responseRef = await addDoc(job_collection_ref, formattedData);
  await updateDoc(responseRef, { id: responseRef.id });

  return responseRef;
};

export const usePostJobs = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postJobs,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.JOBS] });
    },
  });
};